<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="职位管理">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-button plain hairline type="primary" icon="add-o" size="small"
                      @click="addJob">单个添加</van-button>
        </template>
      </van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item title="公司" v-model="companyId" :options="companyOption" @change="handleSearch(companyId, state, keyword)" />
        <van-dropdown-item title="状态" v-model="state" :options="stateOption" @change="handleSearch(companyId, state, keyword)" />
      </van-dropdown-menu>
      <van-search clearable placeholder="请输入关键词"
                  v-model="keyword" @search="handleSearch(companyId, state, keyword)" />
    </div>

    <div class="apply-body" ref="root">
      <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">
        <van-empty v-if="dataList.length < 1" description="暂无岗位数据" />
        <van-cell-group v-if="dataList.length > 0">
          <van-swipe-cell v-for="data in dataList" :key="data">
            <van-cell :key="data"
                      :title="data['title']"
                      @click="editJob(data)"
                      :border="true"
                      :style="(data['state'] === '0') ? this.style0 : (data['state'] === '-1') ? this.style_1 : {}">
              <template #label>
                <van-row>
                  <span>{{ data['city'] }} · {{ data['company'] }}</span>
                </van-row>
              </template>
            </van-cell>
            <template #left>
              <van-button style="height: 100%" square type="danger" icon="delete-o" text="删除"
                          @click="deleteJob(data['jobId'])"
                          v-if="data['state'] === '0'"/>
            </template>
            <template #right>
              <van-button style="height: 100%" square type="success" icon="passed" text="发布"
                          @click="postJob(data['jobId'])"
                          v-if="data['state'] === '0'" />
              <van-button style="height: 100%" square type="primary" icon="close" text="下架"
                          @click="closeJob(data['jobId'])"
                          v-if="data['state'] === '1'" />
            </template>
          </van-swipe-cell>
        </van-cell-group>
      </van-skeleton>
    </div>

  </div>

</template>

<script>
import {closeJob, deleteJob, getCompanyOption, getJobManageList, postJob} from "@/api";
import {showConfirmDialog, showNotify} from "vant";

export default {
  name: "JobManageList",
  data() {
    return {
      loading: true,
      dataList: [],
      companyId: '',
      state: '',
      keyword: '',
      companyOption: [
        { text: '全部公司', value: '' },
      ],
      stateOption: [
        { text: '未过期', value: '' },
        { text: '已发布', value: '1' },
        { text: '未发布', value: '0' },
        { text: '已过期', value: '-1' },
      ],

      style_1:
          {'background-color': '#FFE5E5', 'color': '#FF7D7D', '--van-cell-label-color': '#FF7D7D', '--van-cell-value-color': '#FF7D7D',},
      style0:
          {'background-color': '#FFFFCC', 'color': '#FF976A', '--van-cell-label-color': '#FF976A', '--van-cell-value-color': '#FF976A',},
    }
  },
  mounted() {
    this.loading = true;
    getCompanyOption().then((res) => {
      if (res.code === 200) {
        for (let data of res.data) {
          this.companyOption.push(data);
        }
      }
    });
    let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    if (userInfo['flag'] >= 0) {
      if (userInfo['flag'] === 0) {
        this.companyId = '';
      } else {
        this.companyId = userInfo['companyId'];
      }
      getJobManageList('companyId=' + this.companyId).then((res) => {
        if (res.code === 200) {
          this.dataList = res.data;
          this.loading = false;
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    }
  },
  methods: {
    goBack() {
      window.history.back();
    },
    editJob(data) {
      this.$router.push({
        name: 'JobForm',
        params: {
          jobId: data['jobId']
        },
      });
      window.sessionStorage.setItem('jobInfo', JSON.stringify(data));
    },
    addJob() {
      this.$router.push({
        name: 'JobForm',
        params: {
          jobId: '0'
        },
      });
    },
    postJob(jobId) {
      showConfirmDialog({
        message: '是否确认发布？',
      }).then(() => {
        postJob('jobId=' + jobId).then((res) => {
          if (res.code === 200) {
            this.handleSearch(this.companyId, this.state, this.keyword);
            showNotify({ type: 'success', message: res.msg, position: 'bottom' });
          } else {
            showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
          }
        });
      }).catch(() => {
        // on cancel
      });
    },
    deleteJob(jobId) {
      showConfirmDialog({
        message: '是否确认删除？',
      }).then(() => {
        deleteJob('jobId=' + jobId).then((res) => {
          if (res.code === 200) {
            this.handleSearch(this.companyId, this.state, this.keyword);
            showNotify({ type: 'success', message: res.msg, position: 'bottom' });
          } else {
            showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
          }
        });
      }).catch(() => {
        // on cancel
      });
    },
    closeJob(jobId) {
      showConfirmDialog({
        message: '是否确认下架？',
      }).then(() => {
        closeJob('jobId=' + jobId).then((res) => {
          if (res.code === 200) {
            this.handleSearch(this.companyId, this.state, this.keyword);
            showNotify({ type: 'success', message: res.msg, position: 'bottom' });
          } else {
            showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
          }
        });
      }).catch(() => {
        // on cancel
      });
    },
    handleSearch(companyId, state, keyword) {
      this.loading = true;
      let obj = null;
      if ((companyId === null || companyId === '') && state === null && (keyword === null || keyword === '')) {
        obj = null;
      } else {
        obj = '';
        if (companyId != null && companyId !== '') {
          obj += ('companyId=' + this.companyId);
        }
        if (state != null) {
          if (obj === '') {
            obj += ('state=' + state);
          } else {
            obj += ('&state=' + state);
          }
        }
        if (keyword != null && keyword !== '') {
          if (obj === '') {
            obj += ('keyword=' + keyword);
          } else {
            obj += ('&keyword=' + keyword);
          }
        }
      }
      getJobManageList(obj).then((res) => {
        if (res.code === 200) {
          this.dataList = res.data;
          this.loading = false;
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    }
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

/deep/ .van-hairline--bottom:after {
  border: none;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .van-dropdown-menu__bar--opened {
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

/deep/ .van-cell__title {
  min-width: 100%;
}

/deep/ .van-cell__value {
  min-width: 0%;
}

/deep/ .van-hairline--top-bottom:after {
  border: none;
}

/deep/ .van-swipe-cell:after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: var(--van-padding-md);
  bottom: 0;
  left: var(--van-padding-md);
  border-bottom: 1px solid var(--van-cell-border-color);
  transform: scaleY(.5);
}
</style>